import CheckBox from './components/index.vue';

CheckBox.install = function(Vue) {
  Vue.component(CheckBox.name, CheckBox)
}

export default CheckBox
